import kamala from '../../kamala'
import Skeleton from './Skeleton'

Skeleton.install = function (Vue) {
  kamala(Vue)

  Vue.component(Skeleton.name, Skeleton)
}

export default Skeleton
